import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CustomEventsService } from 'src/app/shared/services/custom-events/custom-events.service';
import { CustomEventTokens } from 'src/app/shared/models/custom-event-tokens';

import { I18nService } from 'src/app/shared/services/i18n/i18n.service';
import { TranslateService } from '@ngx-translate/core';

import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import { UserService } from '../../services/user.service';
import navigationData from 'src/assets/json/navigation.json';
import { TopLevelMenuItems } from '@enums/toplevel-menu-items.enum';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  standalone: false,
})
export class NavigationComponent implements OnInit {
  @Input('is-large-screen') public isLargeScreen = true;
  private readonly destroyRef = inject(DestroyRef);
  userType!: string;
  navigationData!: any;

  private readonly financingPath = '/secure/financing';
  private readonly baseMenuItems: Array<{
    path: string;
    title: string;
    icon: string;
    visible: boolean;
    queryParams?: Record<string, string>;
  }>;

  constructor(
    private customEventsService: CustomEventsService,
    private i18nService: I18nService,
    public translate: TranslateService,
    private readonly localStorageService: LocalStorageService,
    private readonly userService: UserService
  ) {
    this.baseMenuItems = structuredClone(navigationData).menuItems;
  }

  ngOnInit(): void {
    let claims = this.localStorageService.getLocalStorageItem(
      CustomEventTokens.AGILITY_USER
    )?.claims;
    this.userType = claims?.userType;

    const applyNav = () => {
      const showFinancing =
        !this.userService.isSubTenant &&
        this.userService.checkFeatureFlag(TopLevelMenuItems.FINANCING);
      this.navigationData = this.baseMenuItems.map((item) =>
        item.path === this.financingPath
          ? { ...item, visible: showFinancing }
          : item
      );
    };
    applyNav();
    this.userService.featureFlags$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => applyNav());

    this.i18nService
      .getLanguage()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((language: string) => {
        this.translate.use(language);
      });
  }

  onMobileNavItemClick(): void {
    this.customEventsService.setEvent({
      name: CustomEventTokens.MOBILE_NAV_ITEM_CLICKED,
    });
  }
}
